import { Fancyapps } from "@Libraries/Fancyapps";

import "./_Reviews.scss";

export class Reviews
{
	FilterReviews: HTMLElement;
	ReviewContainer: HTMLElement;
	SortReviews: HTMLElement;
	SelectedFilter: HTMLInputElement;
	SelectedSort: HTMLInputElement;

	constructor()
	{
		this.ReviewContainer = document.querySelector(".review");
		this.FilterReviews = document.getElementById("filterReviews") as HTMLElement;
		this.SortReviews = document.getElementById("sortReviews") as HTMLElement;
		this.SelectedFilter = document.querySelector("input[name=RatingFilter]:checked");
		this.SelectedSort = document.querySelector("input[name=SortOrder]:checked");

		if (document.querySelectorAll(".review__item").length > 0)
		{
			this.BindFilter();
			this.BindSort();
			this.BindReviewImages();
		}

		this.BindWriteLinks();
	}

	private BindFilter = (): void =>
	{
		if (this.FilterReviews != null)
		{
			this.FilterReviews.addEventListener("change", this.FilterHandler);
		}
	};

	private BindReviewImages = (): void =>
	{
		const images = this.ReviewContainer.querySelectorAll(".review__img");

		images.forEach((image) =>
		{
			image.addEventListener("click", this.DisplayReviewImages);
		});
	};

	private BindSort = (): void =>
	{
		if (this.SortReviews !== null)
		{
			this.SortReviews.addEventListener("change", this.SortHandler);
		}
	};

	private BindWriteLinks = (): void =>
	{
		const writeLinks = document.querySelectorAll("#review-link, #hlWriteReview1, #hlWriteReview2");

		writeLinks.forEach((link): void =>
		{
			link.addEventListener("click", this.DisplayReviewModal);
		});
	};

	private DisplayReviewImages = async (e: Event): Promise<void> =>
	{
		e.preventDefault();
		const target = e.currentTarget as HTMLElement;
		const parent = target.closest(".review__item");
		const index = target.getAttribute("data-index");
		const images = parent.querySelectorAll(".review__img");
		const slides = [];
		let startIndex = 0;

		if (typeof index !== "undefined" && index !== "")
		{
			startIndex = parseInt(index) - 1;
		}

		images.forEach((image: HTMLLinkElement) =>
		{
			const slide = {
				src: image.href,
				type: "image",
				thumb: image.href
			};

			slides.push(slide);
		});

		const fancyapps = await Fancyapps.Import();
		const reviewImages = new fancyapps.Fancybox(slides, {
			startIndex: startIndex
		});
	};

	private DisplayReviewModal = async (e: Event): Promise<void> =>
	{
		e.preventDefault();
		const productID = (document.getElementById("ProductID") as HTMLInputElement).value;
		const url = "/account/review-product/" + productID + "?isModal=true";
		const fancyapps = await Fancyapps.Import();
		const reviewModal = new fancyapps.Fancybox(
			[
				{
					src: url,
					type: "iframe"
				}
			],
			{
				mainClass: "review-modal"
			}
		);
	};

	private FilterHandler = (e: Event): void =>
	{
		const filterValue = parseInt(this.FilterReviews.getAttribute("data-value"));
		const reviews = this.ReviewContainer.querySelectorAll(".review__item");

		reviews.forEach((review: HTMLElement) =>
		{
			const ratingInput = review.querySelector(`input[name="rating"]`) as HTMLInputElement;
			const rating = parseInt(ratingInput.value);

			if (rating >= filterValue)
			{
				review.style.display = "";
			}
			else
			{
				review.style.display = "none";
			}
		});
	};

	private SortHandler = (e: Event): void =>
	{
		const sortValue = this.SortReviews.getAttribute("data-value");
		const reviews = this.ReviewContainer.querySelectorAll(".review__item");
		const reviewsArray = Array.prototype.slice.call(reviews, 0);
		const selector = `input[name="${sortValue}"]`;

		const sortedReviews = reviewsArray
			.sort((a: HTMLElement, b: HTMLElement) =>
			{
				const aEl = a.querySelector(selector) as HTMLInputElement;
				const bEl = b.querySelector(selector) as HTMLInputElement;
				const aPos = parseInt(aEl.value);
				const bPos = parseInt(bEl.value);

				return (aPos < bPos) ? -1 : (aPos > bPos) ? 1 : 0;
			})
			.map((review: HTMLElement) =>
			{
				return review.outerHTML;
			});

		this.ReviewContainer.querySelector(".list-group").innerHTML = sortedReviews;

		this.BindReviewImages();
	};
}